import { InputProps, SelectInput } from "react-admin"

import { UnitChoices } from "../billing_constants"

export const UnitSelectInput: React.FC<InputProps> = (props) => (
  <SelectInput label="Unit" {...props} choices={UnitChoices} />
)
